const announcements = [
  {
    id: 1,
    title: "2024 Bahar Dönemi Ders Programı",
    date: "2024-01-15",
    content: "2024 Bahar dönemi ders programı yayınlanmıştır. Detaylar için lütfen ders sayfasını ziyaret ediniz.",
    category: "Ders"
  },
  {
    id: 2,
    title: "Yüksek Lisans Tez Savunması",
    date: "2024-01-10",
    content: "Sayın [Öğrenci Adı]'nin yüksek lisans tez savunması 25 Ocak 2024 tarihinde saat 14:00'te yapılacaktır.",
    category: "Etkinlik"
  },
  {
    id: 3,
    title: "Yeni Araştırma Projesi Duyurusu",
    date: "2024-01-05",
    content: "TÜBİTAK destekli yeni araştırma projemiz başlamıştır. Proje detayları için lütfen iletişime geçiniz.",
    category: "Araştırma"
  },
  {
    id: 4,
    title: "Konferans Katılımı",
    date: "2023-12-20",
    content: "Uluslararası Yapay Zeka Konferansı'nda bildiri sunumu gerçekleştirilmiştir.",
    category: "Etkinlik"
  }
];

export default announcements;

